'use client';

import { Fragment, Suspense, useEffect, useLayoutEffect } from 'react';
import React from 'react';
import { Separator } from '@/components/ui/separator';
import { useTableSample } from '@/hooks/swr/useTableSample';
import { useTableStatistics } from '@/hooks/swr/useTableStatistics';
import logger from '@/lib/logger';
import { Dataset } from '@/lib/types/Dataset';
import { Table } from '@/lib/types/Table';
import { combineColumnStatistics } from '../statisticsHelper';
import { TableDetailsItem } from './TableDetailsItem';
import { TableDetailsSkeleton } from './TableDetailsSkeleton';
interface TableDetailsProps {
  dataset: Dataset;
  table: Table;
}
export const TableDetails = ({
  dataset,
  table
}: TableDetailsProps) => {
  const {
    data: tableStatistics,
    isLoading: isStatsLoading
  } = useTableStatistics(dataset.id, table.id);
  const {
    data: tableSample,
    isLoading: isSampleLoading
  } = useTableSample(dataset.id, table.id);
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        if (document) {
          const el = document.querySelector(hash);
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth'
            });
          } else {
            logger.warn('Unable to find anchor element');
          }
        }
      }, 100);
    }
  });
  if (isSampleLoading || isStatsLoading) {
    return <TableDetailsSkeleton amount={Object.keys(table.columns).length} />;
  }
  const combinedStats = combineColumnStatistics({
    tableColumns: table.columns,
    tableStatistics,
    descriptionFormat: 'markdown'
  });
  return <Suspense fallback={<TableDetailsSkeleton amount={Object.keys(table.columns).length} />}>
      <div className="p-5 bg-white">
        {combinedStats.map((column, index) => <Fragment key={`table-${table.id}-column-${column.name}`}>
            {index > 0 && <Separator className="my-4" />}
            <TableDetailsItem sample={tableSample ?? []} columnWithStats={column} />
          </Fragment>)}
      </div>
    </Suspense>;
};